module.exports = __webpack_public_path__ + "static/media/folder-upper.d5c7f5e4.png";